import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { TranslatorPipe } from 'src/app/services/translator.pipe';
import { link, breadcrumb, stat } from 'src/app/admin/layout/header/header.component';
import { Message, ConfirmationService, ConfirmEventType } from 'primeng/api';
import { MsPermissionService } from 'src/app/services/ms-permission.service';


@Component({
  selector: 'app-ms-calender',
  templateUrl: './ms-calender.component.html',
  styleUrls: ['./ms-calender.component.scss', '../../../../mystery-shopper/mystery-shopper.component.scss']

})
export class MsCalenderComponent {
  daysOfWeek: string[] = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  calendarData: any[] = [];
  skelition = false;
  currentDate: Date = new Date();
  apiData: any = []
  modalData: any
  showDilogue = false
  channels: any = []
  sessions: any[] = [];
  header: string = this.translate("Visit Calendar");
  links: link[] = [
    {
      name: this.translate('Back'),
      icon: 'pi pi-refresh',
      link: '/ms/project',
    }
  ];
  breadcrumbs: breadcrumb[] = [
    { name: this.translate('Project'), link: '/ms/project' },
    { name: this.translate('Visit Calendar'), link: '/ms/calender' },
  ];
  messages: Message[] = [];
  projectId: string = '';
  project: any;
  selectedBranches: any[] = [];
  selectedBranchesProject: any[] = [];
  basicChannels: Array<any> = []
  statusType: string = '';
  hasStatusDB: boolean = true;
  pmComment: string = '';
  stepStatus: any = [];
  isInternalPM: boolean = false;
  branches: Array<any> = []
  projectVisits: any;
  evaluationEnabled: boolean = false;
  evaluations: any;
  evaluationsStatus: any;
  projectStatus: any[] = [
    { name: "Weights", status: "", link: "/ms/assign-weights/" },
    { name: "Criteria", status: "", link: "/ms/criterias/" },
    { name: "Enquiries", status: "", link: "/ms/factor/" },
    { name: "Calander", status: "", link: "/ms/calender/" },
    { name: "Evaluation", status: "", link: "/ms/evaluation/" }
  ];

  sessionStart: any;
  sessionEnd: any;

  sessionID: string = ''
  @Input() projectID: string = '65c7e18f8cae88709349005e'


  @Output() showTraining: EventEmitter<any> = new EventEmitter();

  constructor(
    private dataService: DataService,
    private route: ActivatedRoute,
    private confirmationService: ConfirmationService,
    private router: Router) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.projectID = params['projectId'];
      if (this.projectID) {
        this.getSession().then(() => {
          this.getProject(this.projectID).then(() => {

            let pm = MsPermissionService.checkUserPermissions(this.project);
            if (pm == true) {
              this.isInternalPM = true;
            } else if (pm == false) {
              this.router.navigate(['/ms/project'])
              return;
            }

            this.getBranches()
            this.getProjectVisitsSessions(this.projectID)
            this.getData().then(() => {
              this.generateCalendarDays();
              this.getStepStatusByProject()
              this.getStepStatus().then(() => {
                this.skelition = false;
              })
            })
          })
        })
      }
    })
  }


  ngOnChanges() {
    this.getProject(this.projectID).then(() => {
      this.getBranches()
      this.getProjectVisitsSessions(this.projectID)
      this.getData().then(() => {
        this.generateCalendarDays();
        this.getStepStatusByProject()
        this.getStepStatus().then(() => {
          this.skelition = false;
        })
      })
    })
  }


  showTrainingDetail(req: any) {
    this.showTraining.emit(req);
  }

  async getProject(id: string) {
    try {
      this.skelition = true;
      let res = await this.dataService.getData(`ms-project/${id}`)
      if (res.error) {
        console.log(res.error);
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ]
        return;
      }
      this.project = res.data.data;
      this.channels = res.data.channels.filter((item: any) => item.type == 'Basic')
      this.basicChannels = res.data.channels.filter((item: any) => item.type == 'Basic')
      this.hasBranches = this.basicChannels.some(channel => channel.name === "Branches");
      this.selectedBranches = res.data.channels.filter((item: any) => item.type == 'Branch')
      this.selectedBranchesProject = res.data.channels.filter((item: any) => item.type == 'Branch')
      this.skelition = false;
    } catch (e: any) {
      this.messages = [
        { severity: 'error', summary: this.translate('error'), detail: e.toString() },
      ]
    }
  }

  async getProjectVisitsSessions(id: string) {
    try {
      this.skelition = true;
      console.log('ms-channel/visit/${id}/${this.sessionID}', id + ' - ' + this.sessionID);
      let res = await this.dataService.getData(`ms-channel/visit/${id}/${this.sessionID}`)
      if (res.error) {
        console.log(res.error);
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ]
        return;
      }
      this.projectVisits = res.data;

      console.log("this.projectVisits", this.projectVisits);

      for (let channelIndex = this.channels.length - 1; channelIndex >= 0; channelIndex--) {
        const channel = this.channels[channelIndex];
        if (channel.name === 'Branches') {
          const ChannelVisits = this.projectVisits.filter((visit: any) => visit.name === 'Branches');
          if (ChannelVisits.length > 0) {
            const BranchVisits = ChannelVisits[0].CountofCreatedSessionforChannel;
            const BranchVisitsCount = ChannelVisits[0].visitCount;
            if (this.selectedBranches.length > 0) {
              let branchCount = this.selectedBranches.length;
              for (let branchIndex = this.selectedBranches.length - 1; branchIndex >= 0; branchIndex--) {
                const branch = this.selectedBranches[branchIndex];
                const visitData = BranchVisits.filter((visit: any) => visit.branch === branch._id);
                if (visitData.length > 0) {
                  if (BranchVisitsCount == visitData.length) {
                    this.selectedBranches.splice(branchIndex, 1);
                    branchCount--;
                  }
                  if (branchCount === 0) {
                    this.channels.splice(channelIndex, 1);
                  }
                }
              }
            }
          }

        } else {
          const visitData = this.projectVisits.filter((visit: any) => visit._id === channel._id);
          if (visitData.length > 0) {
            for (let visitIndex = visitData.length - 1; visitIndex >= 0; visitIndex--) {
              const visit = visitData[visitIndex];
              console.log("visit.visitCount", visit.visitCount)
              console.log("visit.CountofCreatedSessionforChannel.length", visit.CountofCreatedSessionforChannel.length)
              if (visit.visitCount == visit.CountofCreatedSessionforChannel.length) {
                this.channels.splice(channelIndex, 1);
              }
            }
          }
        }
      }
      console.log("this.projectVisits", this.projectVisits)
      this.skelition = false;
    } catch (e: any) {
      this.messages = [
        { severity: 'error', summary: this.translate('error'), detail: e.toString() },
      ]
    }
  }

  async getBranches() {
    this.skelition = true;
    try {
      let res = await this.dataService.getData('ou-type/branches');
      if (res.error) return
      this.branches = res.data;
      // this.selectedBranches = this.selectedBranches.map(selectedBranch => {
      //   const matchingBranch = this.branches.find(branch => branch._id === selectedBranch.branchId);
      //   if (matchingBranch) {
      //       selectedBranch.name += " ( " + matchingBranch.location.name + " ) ";
      //       matchingBranch.channelId = selectedBranch._id;
      //       selectedBranch.channelId = selectedBranch._id;
      //   }
      //   return selectedBranch;
      // });

      this.selectedBranches.forEach((selectedBranch, index) => {
        const matchingBranchIndex = this.branches.findIndex(branch => branch._id == selectedBranch.branchId);
        if (matchingBranchIndex !== -1) {
          this.selectedBranches[index].name = this.selectedBranches[index].name + " ( " + this.branches[matchingBranchIndex].location.name + " ) ";
          this.branches[matchingBranchIndex].channelId = selectedBranch._id;
          this.selectedBranches[index].channelId = selectedBranch._id;
        }
      });
      this.skelition = false;
    } catch (error) {
      console.log(error)
    }
  }

  branchMappings() {

  }

  async getSession() {
    try {
      let res = await this.dataService.getData(`ms-sessions/project/1/1000/` + this.projectID);
      if (res.error) return;
      this.sessions = res.data;

      console.log("this.sessions[0]", this.sessions[0])
      this.sessionID = this.sessions[0]._id;
      this.sessionStart = new Date(this.sessions[0].startDate);
      this.sessionEnd = new Date(this.sessions[0].endDate);
    } catch (error) {
      console.log(error)
    }
  }

  async createSession() {
    try {
      let session = {
        startDate: this.currentDate,
        endDate: this.currentDate,
        projectId: this.projectID,
        visits: {
          data: []
        }
      }
      let res = await this.dataService.postData('ms-sessions', session);
      if (res.error) return
      this.sessionID = res.data._id
    } catch (error) {
      console.log(error)
    }
  }



  generateCalendarDays(): void {
    const currentMonth = this.currentDate.getMonth();
    const currentYear = this.currentDate.getFullYear();
    const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();

    this.daysOfWeek = this.daysOfWeek.slice(this.daysOfWeek.indexOf('Sunday')).concat(this.daysOfWeek.slice(0, this.daysOfWeek.indexOf('Sunday')));

    const firstDayOfMonth = new Date(currentYear, currentMonth, 1).getDay();
    const startingDay = (firstDayOfMonth - this.daysOfWeek.indexOf('Sunday') + 7) % 7;

    this.calendarData = [];

    let currentRow: any[] = [];
    for (let day = 1; day <= daysInMonth + startingDay; day++) {
      const dayNumber = day - startingDay;

      const dateKey = `${currentYear}-${currentMonth + 1}-${dayNumber}`;

      const dayData = this.apiData.find((data: any) => {
        return data._id.year === currentYear && data._id.month === currentMonth + 1 && data._id.day === dayNumber;
      });

      currentRow.push({
        _id: { year: currentYear, month: currentMonth + 1, day: dayNumber },
        data: dayData ? dayData.data : []
      });

      if (currentRow.length === 7) {
        this.calendarData.push(currentRow);
        currentRow = [];
      }
    }

    // Add the last row if it's not complete
    if (currentRow.length > 0) {
      this.calendarData.push(currentRow);
    }

    console.log("this.calendarData", this.calendarData);

  }

  formatMonthAndYear(): string {
    return this.translate(this.currentDate.toLocaleDateString('en-US', { month: 'long' })) + " " + this.currentDate.toLocaleDateString('en-US', { year: 'numeric' });
  }

  nextMonth(): void {
    this.currentDate.setMonth(this.currentDate.getMonth() + 1);
    this.getData().then(() => {
      this.generateCalendarDays();
    })
  }

  prevMonth(): void {
    this.currentDate.setMonth(this.currentDate.getMonth() - 1);
    this.getData().then(() => {
      this.generateCalendarDays();
    })
  }

  onSessionChange() {
    this.messages = [];
    this.hasStatusDB = true;
    this.statusType = "";
    this.pmComment = "";
    const session = this.sessions.find(session => session._id === this.sessionID);

    if (session) {
      this.sessionStart = new Date(session.startDate);
      this.sessionEnd = new Date(session.endDate);
    }

    this.getProject(this.projectID).then(() => {
      this.getBranches().then(() => {
        this.getProjectVisitsSessions(this.projectID)
        this.getData().then(() => {
          this.generateCalendarDays();
          this.getStepStatusByProject()
          this.getStepStatus().then(() => {
            this.skelition = false;
          })
        })
      })

    })
  }

  async getData() {
    try {
      let res = await this.dataService.getData(`ms-sessions/calender/` + this.sessionID);
      if (res.error) return;
      this.apiData = res.data;
    } catch (error) {
      console.log(error)
    }
  }

  getLastDayOfMonth(date: Date): Date {
    // Create a new date based on the input date
    const lastDay = new Date(date);

    // Set the date to the last day of the month
    lastDay.setMonth(lastDay.getMonth() + 1, 0);

    return lastDay;
  }

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  openTraining(id: any) {
    //emmiter 
  }


  sessionData: any = []

  selectChanel: any
  selectBranch: any
  selectedDate: any
  selectedTime: any
  selectedSession: any
  hasBranches: boolean = false;


  getModalData(modalData: any) {
    this.modalData = modalData
  }

  convertToDate(dateObject: any) {
    return new Date(dateObject.year, dateObject.month - 1, dateObject.day + 1);
  }

  addVisit() {
    this.selectChanel
    this.selectedDate
    this.selectedTime
    this.modalData


    let createObject = {
      channel: this.selectChanel,
      date: this.convertToDate(this.modalData?._id),
      time: this.selectedTime,
      status: "Pending"
    }

    // let objectTopush : any = {
    //   'visits[0].data[0].channel.name' : this.selectChanel.name
    // }


    let dataToAdd: any = {
      visits: [
        {
          data:
          {
            channel: {
              name: this.selectChanel.name,
            }
          },
          time: this.selectedTime

        }
      ]
    }

    if (this.selectChanel.name === 'Branches') {
      dataToAdd.visits[0].data['branch'] = {
        name: this.selectBranch.name
      };
    }

    this.sessionData.push(createObject)
    this.modalData.data.push({ ...dataToAdd })
    this.submitVisit(createObject);
    this.showDilogue = false

  }

  resetModalData() {
    this.selectChanel = undefined
    this.selectBranch = undefined
    this.selectedDate = undefined
    this.selectedTime = undefined
  }

  async submitVisit(visit: any) {
    try {
      let id = visit.channel.id
      visit.channel = this.selectChanel?._id

      if (this.selectChanel.name == 'Branches') {
        visit.branch = this.selectBranch?.channelId
      }

      console.log("Visit", visit);

      let res = await this.dataService.postData('ms-sessions/add-visit/' + this.sessionID, visit, 'PUT', false)
      this.resetModalData();
      this.getProject(this.projectID).then(() => {
        this.getBranches()
        this.getProjectVisitsSessions(this.projectID)
        this.getData().then(() => {
          this.generateCalendarDays();
          this.getStepStatusByProject()
          this.getStepStatus().then(() => {
            this.skelition = false;
          })
        })
      })
    } catch (error) {
      console.log(error)
    }
  }

  showDialog(dayData: any) {
    this.getModalData(dayData);
    this.showDilogue = true
  }

  DeleteVisit(event: Event, visit: any): void {
    event.stopPropagation();
    this.confirm({
      message: this.translate('Are you sure you want to do this?'),
      header: this.translate('Confirmation message'),
      icon: 'pi pi-exclamation-triangle',
      action: async () => {
        try {
          let sessionId = visit._id;
          let visitIdToDelete = visit.visits.data._id;
          this.skelition = true;
          let res = await this.dataService.deleteData('ms-sessions/visit/' + sessionId + '/' + visitIdToDelete);
          if (res.error) {
            this.messages = [
              { severity: 'error', summary: this.translate('error'), detail: res.msg },
            ];
            return;
          }
          this.messages = [
            { severity: 'success', summary: this.translate('success') },
          ];
          this.ngOnInit();
          this.skelition = false;
        } catch (error) {
          console.log(error);
        }
      },
    });
    console.log("Visit", visit)
  }

  isDayDataWithinSession(dayData: any, sessionStart: Date, sessionEnd: Date): boolean {
    const sessionStartDate = new Date(sessionStart.getFullYear(), sessionStart.getMonth(), sessionStart.getDate());
    const sessionEndDate = new Date(sessionEnd.getFullYear(), sessionEnd.getMonth(), sessionEnd.getDate());
    const dayDataDate = new Date(dayData._id.year, dayData._id.month - 1, dayData._id.day, 0, 0, 0);
    return dayDataDate >= sessionStartDate && dayDataDate <= sessionEndDate;
  }


  validateDayData(dayData: any): void {
    const isWithinSession = this.isDayDataWithinSession(dayData, this.sessionStart, this.sessionEnd);
    if (dayData._id.day <= 0 || (this.isInternalPM || this.isInternalUserPM(this.project.internalPm)) || this.statusType == 'Approved' || this.statusType == 'Pending') {
      return;
    }
    if (isWithinSession == false) {
      this.messages = [
        { severity: 'error', summary: this.translate('error'), detail: this.translate("You cannot add Visit outside Session Date") },
      ];
      return;
    }
    if (this.channels.length == 0) {
      this.messages = [
        { severity: 'error', summary: this.translate('error'), detail: this.translate("You have Added All Visit for this Session") },
      ];
      return;
    }
    this.showDialog(dayData);
  }

  async getStepStatus() {
    this.skelition = true;
    try {
      let vendorType = (this.isInternalPM || this.isInternalUserPM(this.project.internalPm)) ? 'internal' : 'external';
      let res = await this.dataService.getData('ms-step/session/' + this.projectID + '/' + this.sessionID + '/Calander/' + vendorType);
      if (res.error) {
        this.hasStatusDB = false;
        return
      }
      this.stepStatus = res.data;

      if (this.stepStatus) {
        this.statusType = this.stepStatus.approvalStatus;
        if (this.statusType == 'Redo' || this.statusType == 'Change') {
          this.pmComment = this.stepStatus.comments;
        }
      }

      console.log("this.statusType", this.statusType);

      this.skelition = false;
    } catch (error) {
      console.log(error)
    }
  }

  async pendingStatus() {
    try {
      let approveData: any = {
        projectId: this.projectID,
        sessionId: this.sessionID,
        approvalStatus: 'Pending',
        comments: this.pmComment,
        step: 'Calander',
        doneBy: localStorage.getItem('uid'),
      };
      this.skelition = true;
      let res = await this.dataService.postData('ms-step', approveData);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success') },
      ];
      this.ngOnInit();
    } catch (error) {
      console.log(error);
    }
  }

  approveStatus() {
    this.confirm({
      message: this.translate('Are you sure you want to do this?'),
      header: this.translate('Confirmation message'),
      icon: 'pi pi-exclamation-triangle',
      action: async () => {
        try {
          let approveData: any = {
            projectId: this.projectID,
            sessionId: this.sessionID,
            approvalStatus: 'Approved',
            comments: this.pmComment,
            step: 'Calander',
            doneBy: localStorage.getItem('uid'),
          };
          this.skelition = true;
          let res = await this.dataService.postData('ms-step', approveData);
          if (res.error) {
            this.messages = [
              { severity: 'error', summary: this.translate('error'), detail: res.msg },
            ];
            return;
          }
          this.messages = [
            { severity: 'success', summary: this.translate('success') },
          ];
          this.ngOnInit();
          this.skelition = false;
        } catch (error) {
          console.log(error);
        }
      },
    });
  }

  redoStatus() {
    if (this.pmComment == '') {
      this.messages = [
        { severity: 'error', summary: this.translate('error'), detail: this.translate('Please Enter Comments') },
      ];
      return;
    }
    this.confirm({
      message: this.translate('Are you sure you want to do this?'),
      header: this.translate('Confirmation message'),
      icon: 'pi pi-exclamation-triangle',
      action: async () => {
        try {
          let approveData: any = {
            projectId: this.projectID,
            sessionId: this.sessionID,
            approvalStatus: 'Redo',
            comments: this.pmComment,
            step: 'Calander',
            doneBy: localStorage.getItem('uid')
          };
          this.skelition = true;
          let res = await this.dataService.postData('ms-step', approveData);
          if (res.error) {
            this.messages = [
              { severity: 'error', summary: this.translate('error'), detail: res.msg },
            ];
            return;
          }
          this.messages = [
            { severity: 'success', summary: this.translate('success') },
          ];
          this.ngOnInit();
          this.skelition = false;
        } catch (error) {
          console.log(error);
        }
      },
    });
  }

  confirm(parems: any) {
    this.confirmationService.confirm({
      message: parems.message,
      header: parems.header,
      icon: parems.icon,
      acceptLabel: 'نعم',
      rejectLabel: 'لا',
      accept: () => {
        parems.action();
        return true;
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            return false;
          case ConfirmEventType.CANCEL:
            return false;
          default:
            return false;
        }
      },
    });
  }

  getBranchLocation(branchId: string) {
    let branch: any = this.branches.filter((branch: any) => branch.channelId == branchId)
    return (branch.length > 0) ? branch[0].location.name : '';
  }

  submitForApproval() {
    if (this.channels.length > 0) {
      this.messages = [
        { severity: 'error', summary: this.translate('error'), detail: this.translate("Please add all Visit for this Session") },
      ];
      return;
    }
    this.confirm({
      message: this.translate('Are you sure you want to do this?'),
      header: this.translate('Confirmation message'),
      icon: 'pi pi-exclamation-triangle',
      action: async () => {
        this.pendingStatus();
      },
    });
  }

  requestChange() {
    if (this.pmComment == '') {
      this.messages = [
        { severity: 'error', summary: this.translate('error'), detail: this.translate('Please Enter Comments') },
      ];
      return;
    }
    this.confirm({
      message: this.translate('Are you sure you want to do this?'),
      header: this.translate('Confirmation message'),
      icon: 'pi pi-exclamation-triangle',
      action: async () => {
        try {
          let approveData: any = {
            projectId: this.projectID,
            sessionId: this.sessionID,
            approvalStatus: 'Change',
            comments: this.pmComment,
            step: 'Calander',
            doneBy: localStorage.getItem('uid')
          };
          this.skelition = true;
          let res = await this.dataService.postData('ms-step', approveData);
          if (res.error) {
            this.messages = [
              { severity: 'error', summary: this.translate('error'), detail: res.msg },
            ];
            return;
          }
          this.messages = [
            { severity: 'success', summary: this.translate('success') },
          ];
          this.ngOnInit();
        } catch (error) {
          console.log(error);
        }
      },
    });
  }

  async getStepStatusByProject() {
    try {
      let res = await this.dataService.getData('ms-step/project/' + this.projectID);
      if (res.error) return

      let allStepsApproved = true;
      console.log("res.data", res.data);

      this.projectStatus.forEach((projectStep: any) => {
        const matchedStep = res.data.find((step: any) => step._id == projectStep.name);
        if (matchedStep) {
          projectStep.status = matchedStep.approvalStatus;

          if (matchedStep.approvalStatus !== 'Approved') {
            allStepsApproved = false;
          }
          else {
            allStepsApproved = false;
          }
        }
        let stepsToCheck = this.projectStatus.slice(0, this.projectStatus.length - 1);

        console.log("stepsToCheck", stepsToCheck);

        this.evaluationEnabled = stepsToCheck.every(step => step.status === 'Approved');

        console.log("this.evaluationEnabled", this.evaluationEnabled)
      });
    } catch (error) {
      console.log(error)
    }
  }

  isInternalUserPM(internalPm: any) {
    const uid: string = localStorage.getItem('uid') ?? '';
    if (internalPm) {
      if (Array.isArray(internalPm) && internalPm.length > 0) {
        return uid === internalPm[0]._id;
      } else if (typeof internalPm === 'object' && internalPm._id) {
        return uid === internalPm._id;
      }
    }
    return false;
  }
}
